import cryptoJs from 'crypto-js';

// ----------------------------encrypt----------------------------------
// encrypt helps decipher a plain text to unreadable text
// encrypt allowed sending a plain text to backend in much safer ways

export const encrypt = (key, data) => {
  const encryptedJs = cryptoJs.AES.encrypt(data, key).toString();
  return encryptedJs;
};
